<template lang="pug">
  div
    b-row
      .col-xl-4
        panel(:title='$t("ui.password")')
          ChangePassword
        panel(:title='$t("ui.security_code")')
          SecurityCode
      .col-xl-4(v-if="!isTelegramBound")
        panel(:title='$t("ui.setup_otp_via_mobile_authenticator")')
          Otp2fa
      .col-xl-4(v-if="!is2faBound")
        panel(:title='$t("ui.setup_otp_via_telegram_chatbot")')
          OtpTelegram
</template>

<script>
import ChangePassword from "@/components/settings/changePassword";
import SecurityCode from "@/components/settings/securityCode";
import Otp2fa from "@/components/settings/otp2fa";
import OtpTelegram from "@/components/settings/otptelegram";

export default {
  components: {
    ChangePassword,
    SecurityCode,
    Otp2fa,
    OtpTelegram
  },
  computed: {
    isTelegramBound() {
      const telegramStatus = this.$store.getters.getOTPTelegram;
      return telegramStatus === true || telegramStatus === 1;
    },
    is2faBound() {
      const twoFactorStatus = this.$store.getters.get2faValidated;
      return twoFactorStatus === true || twoFactorStatus === 1;
    }
  }
}
</script>